(() => {
  const boot = () => {
    const header = document.querySelector('.header');
    const panel = header?.querySelector('.mm-header-search-takeover');
    if (!panel || panel.dataset.ready) return;
    panel.dataset.ready = 'true';
    const row = header.querySelector('.header-inner');
    const input = panel.querySelector('[name="q"]');
    const triggers = [...header.querySelectorAll('[data-mm-open-search]')];
    let trigger;
    const close = (restore = true) => {
      if (panel.hidden) return;
      panel.hidden = true;
      row.inert = false;
      row.removeAttribute('aria-hidden');
      header.classList.remove('mm-search-is-open');
      triggers.forEach(item => item.setAttribute('aria-expanded', 'false'));
      if (restore) trigger?.focus({preventScroll: true});
    };
    triggers.forEach(item => item.addEventListener('click', event => {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button > 0) return;
      event.preventDefault();
      trigger = item;
      header.querySelector('.mm-menu')?.removeAttribute('open');
      panel.hidden = false;
      header.classList.add('mm-search-is-open');
      row.inert = true;
      row.setAttribute('aria-hidden', 'true');
      triggers.forEach(link => link.setAttribute('aria-expanded', 'true'));
      input.focus({preventScroll: true});
    }));
    panel.querySelector('[data-mm-search-close]').addEventListener('click', () => close());
    panel.addEventListener('keydown', event => {
      if (event.key === 'Escape') { event.preventDefault(); close(); }
    });
    document.addEventListener('click', event => {
      if (!panel.hidden && !header.contains(event.target)) close(false);
    });
    header.addEventListener('focusout', () => {
      requestAnimationFrame(() => {
        if (!panel.hidden && !header.contains(document.activeElement)) close(false);
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once: true});
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
